module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ijurW"))).then(() => parcelRequire('8rm4T'));